import React from "react";

// MUI Imports
import TableBody from "@mui/material/TableBody";

// Component Imports
import CustomerOrderRow from "./CustomerOrderRow";

const CustomerOrderBody = ({
  orderData,
  allCustomerData,
  auth,
  setUpdatedData,
  setTrigger,
}) => {
  const {
    userDetailsInfo: { customerId },
    userPaymentInfo
  } = allCustomerData;
  const orders = orderData?.map((data, idx) => {
    const customerOrderData = {
      campaign: data && data.campaignName ? data.campaignName : null,
      brand: data && data.brand ? data.brand : null,
      orderTotal: data && data.orderTotal ? data.orderTotal : null,
      orderMessage: data && data.orderMessage ? data.orderMessage : null,
      sku: data && data.sku ? data.sku : null,
      orderNumber: data && data.orderId ? data.orderId : null,
      date: data && data.orderDate ? data.orderDate : null,
      status: data && data.orderStatus ? data.orderStatus : null,
      products: data && data.products ? data.products : null,
      transactionDetails:
        data && data.transactionViews ? data.transactionViews : null,
        parentOrderId: data && data.parentOrderId ? data.parentOrderId : null,
    };
    return customerOrderData;
  }).sort((a, b) => {
    return a.orderNumber - b.orderNumber
  });

  return (
    <TableBody className="table-background-color">
      {orders?.map((orderData, idx) => (
        <CustomerOrderRow
          key={idx}
          row={orderData}
          orderPaymentData={userPaymentInfo}
          customerId={customerId}
          auth={auth}
          setUpdatedData={setUpdatedData}
          setTrigger={setTrigger}
        />
      ))}
    </TableBody>
  );
};

export default CustomerOrderBody;
